import constantObject from 'utilities/constantObject';

export const ATTACHMENT_TYPES = constantObject([
  'LOADING',
  'CARD',
  'FILE',
  'COMMAND',
]);

export const TAG_TYPES = constantObject([
  'NOTIFY',
  'USER',
  'CARD',
  'PAGE',
  'GROUP',
  'HASHTAG',
  'MARKUP',
  'MARKDOWN',
]);

export const NON_USER_TAG_TYPES = [TAG_TYPES.CARD, TAG_TYPES.HASHTAG];
export const ALL_TAG_TYPES = Object.keys(TAG_TYPES);
